import { ActionType } from '../../../components/modals/v2/connectors/helpers';

export function createConnectionApiAction(options?: { includeNullData?: boolean }) {
  return {
    type: ActionType.API_ENDPOINT,
    requestConfig: {
      url: '/api/connector/v1/connections',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      ...(options?.includeNullData && { data: null }),
    },
  };
}

export function createFullWidthRowLayout(columnCount: number) {
  const columnProps: Record<number, { xs: number; md: number }> = {};
  const elementContainerProps: Record<number, Record<string, never>> = {};

  for (let columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
    columnProps[columnIndex] = { xs: 12, md: 12 };
    elementContainerProps[columnIndex] = {};
  }

  return {
    columns: columnCount,
    containerProps: { spacing: 2, direction: 'row' as const },
    columnProps,
    elementContainerProps,
  };
}

export function createConnectorAddedSuccessStep(description: string) {
  return {
    name: 'Step 2',
    elements: [
      {
        type: 'description',
        description,
        column: 0,
      },
    ],
    layout: createFullWidthRowLayout(1),
    action: {
      type: ActionType.CLOSE_MODAL,
    },
  };
}
